import Select from "react-select";

const CitySelect = ({ cities, loading, error, formData, handleInputChange,setShipping }) => {
  const cityOptions = cities?.map((city) => ({ value: city.shipping_charges, label: city.city }));

  return (
    <div>
      <label className="block text-sm font-medium">
        Select city from dropdown
      </label>
      {loading ? (
        <p className="text-sm text-gray-500">Loading cities...</p>
      ) : error ? (
        <p className="text-sm text-red-500">Error loading cities: {error}</p>
      ) : (
        <Select
          options={cityOptions}
          value={cityOptions.find((option) => option.value === formData.city)}
          onChange={(selectedOption) => {
            if (selectedOption) {
              handleInputChange({
                target: { name: "city", value: selectedOption.label },
              });
              setShipping(selectedOption.value);
            } else {
              handleInputChange({ target: { name: "city", value: "" } });
              setShipping(0);
            }
          }}
          placeholder="Please select a city"
          isClearable
          required
          className="react-select-container"
          classNamePrefix="react-select"
        />
      )}
    </div>
  );
};

export default CitySelect;
